import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactOrganizerForm({ eventId, eventName }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    sender_name: '',
    sender_email: '',
    message: ''
  });
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    try {
      await axios.post(`${API_URL}/events/${eventId}/messages`, {
        event_id: eventId,
        sender_name: formData.sender_name,
        sender_email: formData.sender_email,
        message: formData.message
      });

      toast.success(t('messages.sent'));
      setFormData({ sender_name: '', sender_email: '', message: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error sending message');
    } finally {
      setSending(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Mail className="w-5 h-5" />
          {t('messages.send_to_organizer')}
        </CardTitle>
        <p className="text-sm text-gray-600">
          Hai domande su "{eventName}"? Contatta direttamente l'organizzatore.
        </p>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="sender_name">{t('messages.your_name')} *</Label>
            <Input
              id="sender_name"
              value={formData.sender_name}
              onChange={(e) => setFormData({ ...formData, sender_name: e.target.value })}
              required
              placeholder="Mario Rossi"
            />
          </div>

          <div>
            <Label htmlFor="sender_email">{t('messages.your_email')} *</Label>
            <Input
              id="sender_email"
              type="email"
              value={formData.sender_email}
              onChange={(e) => setFormData({ ...formData, sender_email: e.target.value })}
              required
              placeholder="mario.rossi@email.it"
            />
          </div>

          <div>
            <Label htmlFor="message">{t('messages.your_message')} *</Label>
            <Textarea
              id="message"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              required
              placeholder="Scrivi il tuo messaggio all'organizzatore..."
              rows={5}
            />
          </div>

          <Button
            type="submit"
            disabled={sending}
            className="w-full bg-purple-600 hover:bg-purple-700"
          >
            {sending ? 'Invio...' : t('send')}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
